// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67d5cb2d","239":"42dc665b","453":"3518850c","455":"1f8f3982","857":"af62a41a"}[chunkId] + ".chunk.js";
};